<ion-tabs>
	<ion-tab-bar slot="top">
		<ion-tab-button *ngFor="let tab of tabs" [tab]="tab.href">
			<ion-label>{{ tab.title }}</ion-label>
		</ion-tab-button>
	</ion-tab-bar>

	<ion-footer>
		<ion-toolbar>
			<ion-buttons slot="start" collapse="false">
				<ion-button
					*ngIf="allowProvisioning"
					expand="full"
					color="primary"
					fill="solid"
					(click)="provisionChanges()"
					class="button button--provision"
				>
					<span class="provision-text">
						Provision Changes
					</span>
				</ion-button>
			</ion-buttons>
			<ion-buttons slot="end" collapse="false">
				<ion-button
					(click)="onClickAddInventory()"
					color="primary"
					fill="solid"
					shape="round"
					size="large"
					class="button button--add"
				>
					<ion-icon name="add-outline"></ion-icon>
				</ion-button>
			</ion-buttons>
		</ion-toolbar>
	</ion-footer>
</ion-tabs>
